// @flow
import numberWithCommas from "../../../utils/helpers/numberCommas";

const getStatsPresenter = (props) => {
  const {
    updated_at: updatedAt,
    statuses,
    top_categories: topCategories,
    top_sources: topSources,
  } = props;

  const formattedStatuses = statuses.map((row) => {
    const { id, name, total } = row;
    return {
      id,
      name,
      total: numberWithCommas(total),
    };
  });

  const formattedTopCategories = topCategories.map((row) => {
    const { id, name, total } = row;
    return {
      id,
      name,
      total: numberWithCommas(total),
    };
  });

  const formattedTopSoures = topSources.map((row) => {
    const { id, name, total } = row;
    return {
      id,
      name,
      total: numberWithCommas(total),
    };
  });

  const totalReport = numberWithCommas(
    statuses.reduce((accum, status) => accum + status.total, 0)
  );

  return {
    updatedAt,
    statuses: formattedStatuses,
    topCategories: formattedTopCategories,
    topSources: formattedTopSoures,
    totalReport,
  };
};

export default getStatsPresenter;
